module.exports = __webpack_public_path__ + "img/xueShan6.02a3ab6c.png";